import BackToTop from '@/components/BacktoTop/BackToTop';
import { HammerFooter as Footer } from '@/components/Footer/HammerFooter';
import { HammerHeader as Header } from '@/components/Header/HammerHeader';
import { HealthCheckOverlay } from '@/components/HealthCheck/HealthCheckOverlay';
import Modals from '@/components/Modals/Modals';
import SailthruInit from '@/components/Sailthru/SailthruInit';

import AppHeaderMeta from './AppHeaderMeta';

type Props = {
    children: React.ReactNode;
    showHeaderAndFooter: boolean;
};

const AppJSX = ({ children, showHeaderAndFooter }: Props) => (
    <div className="relative h-full w-full print:overflow-visible">
        <AppHeaderMeta />
        <SailthruInit />
        {showHeaderAndFooter && <Header />}
        <main
            className="h-full min-[1240px]:mx-auto print:absolute print:top-0 print:bottom-0 print:m-auto print:mt-0! print:h-full print:w-full"
            id="main"
        >
            {children}
        </main>
        {showHeaderAndFooter && <Footer />}
        <HealthCheckOverlay />
        <Modals />
        <BackToTop />
    </div>
);

export default AppJSX;
